import { render, staticRenderFns } from "./CategoryTag.vue?vue&type=template&id=9b96f86e&"
import script from "./CategoryTag.vue?vue&type=script&lang=js&"
export * from "./CategoryTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports